import nl from './nl';
import en from './en';

export const languages = {
  nl,
  en,
};
